import { Range } from '@attain-apps/range'

import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Metrics',
      type: 'report-card',
      content: {
        if: [
          [
            {
              not: {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
            },
            {
              '[]': [
                {
                  '{}': {
                    name: 'Space Metrics',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'ASF',
                            value: {
                              '{}': {
                                aside: 'Sq. Ft.',
                                quality: 'good',
                                tooltip: 'Total Assignable Square Footage',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'Total Area',
                            value: {
                              '{}': {
                                aside: 'Sq. Ft.',
                                quality: 'good',
                                tooltip: 'Total Area',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'sqft',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'Utilization',
                            value: {
                              '{}': {
                                aside: 'Sq. Ft.',
                                quality: 'good',
                                tooltip: 'ASF / Total Area',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'sqft',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                      scalar: 100,
                                      suffix: '%',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
          {
            '[]': [
              {
                '{}': {
                  name: 'Total',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'TDC',
                          value: {
                            '{}': {
                              aside: 'goal of 290M',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'tdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        290000000,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip:
                                'Total Direct Cost - All direct expenses charged to a research project.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC',
                          value: {
                            '{}': {
                              aside: 'goal of 210M',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        210000000,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip:
                                'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC Average',
                          value: {
                            '{}': {
                              aside: 'goal of 210M',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'projects',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcInLastThereYears',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            3,
                                          ],
                                        },
                                        210000000,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip: 'MTDC Average',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdcInLastThreeYears',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      3,
                                    ],
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'IDC-R',
                          value: {
                            '{}': {
                              aside: 'goal of 150M',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'idcr',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        150000000,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip:
                                'Indirect Cost Recovery - Indirect costs recovered from sponsors based on negotiated rates.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'idcr',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Award Fundings',
                          value: {
                            '{}': {
                              aside: 'goal of 150M',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          if: [
                                            [
                                              {
                                                not: {
                                                  '=': [
                                                    {
                                                      '@$': 'piRecordId',
                                                    },
                                                    null,
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'projects',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'award',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                            {
                                              '+': {
                                                '@': 'awards',
                                              },
                                            },
                                          ],
                                        },
                                        150000000,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip:
                                'Total funding obligated by a sponsor for a specific award.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    if: [
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@$': 'piRecordId',
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'award',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                      {
                                        '+': {
                                          '@': 'awards',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'ASF',
                          value: {
                            '{}': {
                              aside: 'Sq. Ft.',
                              quality: 'good',
                              tooltip: 'Total Assignable Square Footage',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Density',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'TDC Density',
                          value: {
                            '{}': {
                              aside: 'goal of 500 / ASF',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'projects',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'tdc',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        500,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip: 'Total TDC / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'tdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC Density',
                          value: {
                            '{}': {
                              aside: 'goal of 200 / ASF',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'projects',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdc',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        200,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip: 'Total MTDC / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC Avg Density',
                          value: {
                            '{}': {
                              aside: 'goal of 200 / ASF',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': 'projects',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'mtdcInLastThreeYears',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                3,
                                              ],
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        200,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip: '3-Year MTDC Average / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projects',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdcInLastThreeYears',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          3,
                                        ],
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'IDC-R Density',
                          value: {
                            '{}': {
                              aside: 'goal of 100 / ASF',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'projects',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'idcr',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        100,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip: 'Total IDC-R / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'idcr',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Other',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Effective Recovery',
                          value: {
                            '{}': {
                              aside: 'goal of 39%',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'projects',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'idcr',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'projects',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdc',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        0.39,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip:
                                'Actual indirect costs recovered after waivers and cost-sharing adjustments',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'idcr',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                    scalar: 100,
                                    suffix: '%',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Utilization',
                          value: {
                            '{}': {
                              aside: 'goal of 80%',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'sqft',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        0.8,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip:
                                'Percentage of ASF actively used for research.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'sqft',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                    scalar: 100,
                                    suffix: '%',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Collaboration Percentage',
                          value: {
                            '{}': {
                              aside: 'goal of 80%',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'projects',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'collaboration',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': 'projects',
                                              },
                                            },
                                          ],
                                        },
                                        0.8,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip:
                                'Percentage of all projects that are classified as collaborative.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'collaboration',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '#': {
                                          '@': 'projects',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                    scalar: 100,
                                    suffix: '%',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
  },
  subqueries: {
    rooms: {
      filter: {
        and: [
          {
            if: [
              [
                {
                  not: {
                    '=': [
                      {
                        '@$': 'piRecordId',
                      },
                      null,
                    ],
                  },
                },
                {
                  not: {
                    '=': [
                      {
                        '@': 'piAssignments',
                      },
                      null,
                    ],
                  },
                },
              ],
              [
                {
                  and: [
                    {
                      not: {
                        '=': [
                          {
                            '@$': 'orgRecordId',
                          },
                          null,
                        ],
                      },
                    },
                    {
                      not: {
                        '=': [
                          {
                            '@$': 'orgEntityId',
                          },
                          null,
                        ],
                      },
                    },
                  ],
                },
                {
                  not: {
                    '=': [
                      {
                        '@': 'orgAssignments',
                      },
                      null,
                    ],
                  },
                },
              ],
              [
                {
                  and: [
                    {
                      not: {
                        '=': [
                          {
                            '@$': 'spaceRecordId',
                          },
                          null,
                        ],
                      },
                    },
                    {
                      not: {
                        '=': [
                          {
                            '@$': 'spaceEntityId',
                          },
                          null,
                        ],
                      },
                    },
                  ],
                },
                {
                  '=': [
                    {
                      '@$': 'spaceRecordId',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'spaceEntityId',
                              },
                              'ent:!space:!campus',
                            ],
                          },
                          {
                            '@^': '!campus',
                          },
                        ],
                        [
                          {
                            '=': [
                              {
                                '@$': 'spaceEntityId',
                              },
                              'ent:!space:!bldg',
                            ],
                          },
                          {
                            '@^': '!bldg',
                          },
                        ],
                        [
                          {
                            '=': [
                              {
                                '@$': 'spaceEntityId',
                              },
                              'ent:!space:!floor',
                            ],
                          },
                          {
                            '@^': '!floor',
                          },
                        ],
                        {
                          '@.': '!id',
                        },
                      ],
                    },
                  ],
                },
              ],
              true,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        piAssignments: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!space',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@$': 'piRecordId',
                    },
                    null,
                  ],
                },
              },
              {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  {
                    '@.': [
                      '!personnel',
                      {
                        ref: {
                          entity: '!employee',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!person_space:!entry',
          selection: {
            '@.': '!id',
          },
        },
        orgAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@$': 'orgRecordId',
                    },
                    null,
                  ],
                },
              },
              {
                not: {
                  '=': [
                    {
                      '@$': 'orgEntityId',
                    },
                    null,
                  ],
                },
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'orgEntityId',
                            },
                            'ent:!org:!div',
                          ],
                        },
                        {
                          '@.': [
                            '!org',
                            {
                              ref: {
                                entity: '!div',
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              entity: '!dept',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!org_space:!entry',
          selection: {
            '@.': '!id',
          },
        },
      },
    },
    awards: {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'orgEntityId',
                            },
                            'ent:!org:!div',
                          ],
                        },
                        {
                          '@.': [
                            '!org',
                            {
                              ref: {
                                entity: '!div',
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              entity: '!dept',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!awards:!award',
      selection: {
        '@.': '!budget',
      },
    },
    projects: {
      filter: {
        and: [
          {
            not: {
              '=': [
                {
                  '@': 'projectPiAssignments',
                },
                null,
              ],
            },
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'orgEntityId',
                            },
                            'ent:!org:!div',
                          ],
                        },
                        {
                          '@.': [
                            '!org',
                            {
                              ref: {
                                entity: '!div',
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              entity: '!dept',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdc: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          idcr: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'idcrAmount',
                  ],
                },
              ],
            },
          },
          mtdc: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
          award: {
            '@': 'projectAward',
          },
          collaboration: {
            if: [
              [
                {
                  '>': [
                    {
                      '#': {
                        uniq: {
                          '@': 'projectPiDepartments',
                        },
                      },
                    },
                    1,
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcInLastThreeYears: {
            '+': {
              '@': 'glExpensesInLastThreeYears',
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          period: {
            '@$': 'focusedRange',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              tdcAmount: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@.': [
                            '!acct',
                            {
                              ref: {
                                entity: '!acct',
                              },
                            },
                          ],
                        },
                        '?7631013',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              idcrAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@.': [
                            '!acct',
                            {
                              ref: {
                                entity: '!acct',
                              },
                            },
                          ],
                        },
                        '?7631013',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '@': 'isInMtdc',
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        projectAward: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!award',
            inherit: '-',
          },
          target: 'ent:!awards:!award',
          selection: {
            '@.': '!budget',
          },
        },
        projectPiAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@$': 'piRecordId',
                    },
                    null,
                  ],
                },
              },
              {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  {
                    '@.': [
                      '!pi',
                      {
                        ref: {
                          entity: '!employee',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!proj_pis:!entry',
        },
        projectPiDepartments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          target: 'ent:!proj_pis:!entry',
          selection: {
            '@': 'piDept',
          },
          subqueries: {
            piDept: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!pi',
              },
              target: 'ent:!personnel:!employee',
              selection: {
                '@.': [
                  '!org',
                  {
                    ref: {
                      entity: '!dept',
                    },
                  },
                ],
              },
            },
          },
        },
        glExpensesInLastThreeYears: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          filter: {
            '@': 'isInMtdc',
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2024',
              },
              start: {
                $date: '1/1/2022',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
      },
    },
  },
}
